define('home/collections/FollowingUserCollection',[
    'home/collections/PaginatedUserCollection',

    'core/api',
], function (
    PaginatedUserCollection,

    api
) {
    'use strict';

    return PaginatedUserCollection.extend({
        url: api.getURL('users/listFollowing'),
    });
});

